import React from 'react';
import { t } from 'Src/i18n';
import { SimpleNotification } from 'Components/frameworks/notification/SimpleNotification';
import { useFeatureFlip } from 'Src/hooks/use-feature-flip/useFeatureFlip';
import { ICONS } from 'Components/utils/icon/icons';
import {
  calculateTotalEmissions,
  calculateAverageEmissions,
  calculatePercentageDifference,
} from 'Utils/transport/carbonEmissionsUtils';
type TransportsDetailsCarbonEmissionsProps = {
  inbound?: TransportDetail;
  outbound?: TransportDetail;
};
export function TransportsDetailsCarbonEmissions({
  inbound,
  outbound,
}: TransportsDetailsCarbonEmissionsProps) {
  const isCarbonEmissionsEnabled = useFeatureFlip('booking.carbonEmissions');
  // Calculate total emissions for both inbound and outbound
  const inboundSections = inbound?.travelSections || [];
  const outboundSections = outbound?.travelSections || [];
  const allSections = [...inboundSections, ...outboundSections];
  const totalEmissions = calculateTotalEmissions(allSections);
  const totalEmissionsLabel =
    totalEmissions &&
    t('common.transport.carbonEmissionTotal', {
      total: totalEmissions,
    });
  const averageEmissions = calculateAverageEmissions(allSections);
  const percentageDiff = calculatePercentageDifference(totalEmissions, averageEmissions);
  // Build the carbon emission message based on comparison
  let carbonEmissionMessage = null;

  if (isCarbonEmissionsEnabled && allSections.length > 0 && totalEmissions != null) {
    // Determine which message to display based on percentage difference
    if (percentageDiff == null || percentageDiff.percentage === 0) {
      // Emissions equal to average - use carbonEmissionMessage (no percentage)
      carbonEmissionMessage = t('common.transport.carbonEmissionMessage');
    } else if (percentageDiff.isLess) {
      // Emissions less than average - use carbonEmissionLessLabel
      carbonEmissionMessage = t('common.transport.carbonEmissionLessLabel', {
        percentage: `${percentageDiff.percentage}%`,
      });
    } else {
      // Emissions more than average - use carbonEmissionMoreLabel
      carbonEmissionMessage = t('common.transport.carbonEmissionMoreLabel', {
        percentage: `${percentageDiff.percentage}%`,
      });
    }
  }

  if (!isCarbonEmissionsEnabled || !carbonEmissionMessage) {
    return null;
  }

  return (
    <div className="px-20">
      <SimpleNotification
        id="TransportCarbonEmissionInformations"
        content={`${totalEmissionsLabel || ''} ${carbonEmissionMessage}`}
        linkUrl={t('common.transport.carbonEmissionLearnMoreUrl')}
        linkLabel={t('common.transport.carbonEmissionLearnMore')}
        className="mb-20"
        iconName={ICONS.UNION}
      />
    </div>
  );
}
